import axios from 'axios';
import Message from '@/components/Message/index.js';
import session from '@/utils/session.js'
import env from '@/utils/env.js'
import router from '@/router'
import { routes } from '@/config';
import { getHashUrlPathname } from '.';

const axiosInstance = axios.create({
  withCredentials: true,
});

axiosInstance.interceptors.response.use((res) => {
  const response = res.data;
  if (!response) {
    return Promise.reject(new Error('服务器君出小差了，请稍后再试'));
  }
  return res.data;
});

export default function http() {
  return axiosInstance;
}

/**
 * 显示错误消息
 * @param {'error'|'logout'} messageType 消息类型
 */
function showErrorMessage(messageType = 'error', message = '') {
  const messages = {
    error: '服务器君出小差了，请稍后再试',
    logout: '登录过期，请重新登录',
  };
  Message.error(message || messages[messageType]);
}

/**
 * crossToMember参数表示要请求的接口是否是属于会员中心的,
 * 如果为true，则请求会员中心的接口
 */
http.post = function (path, params = {}, crossToMember) {

  let host = env.getHost();
  
  if (crossToMember) {
    host = host.replace('sso', 'member')
  }
  let url = `${host}/api${path}`;
  let payload = {
    token: session.getToken()
  }
  if (!params.noParamsKey) {
    payload.params = params
  } else {
    payload = {
      ...payload,
      ...params
    }
  }
  
  if (/^http[s]?:/.test(path)) {
    url = path
  }
  return axiosInstance.post(url, payload).then(res => {
    if (res.code !== 0) {
      if (res.code === 3304) {
        showErrorMessage('logout')
        session.removeTicket()
      } else if (res.code === 3303 || res.code === 1102) {
        showErrorMessage('logout')
        session.removeToken()
        if (getHashUrlPathname() !== routes.login) {
          router.push({
            path: routes.login,
            query: {
              ...router.app.$route.query
            }
          })
        }
      } else if (res.code !== 3158) {
        showErrorMessage('error', res.msg);
      }
    }
    return res;
  }).catch(err => {    
    showErrorMessage();
    return err;
  });
};

/**
 * crossToMember参数表示要请求的接口是否是属于会员中心的,
 * 如果为true，则请求会员中心的接口
 */
http.put = function (path, params, crossToMember) {
  let host = env.getHost();
  if (crossToMember) {
    host = host.replace('sso', 'member')
  }
  return axiosInstance.put(`${host}/api${path}`, {
    token: session.getToken(),
    params: params
  }).then(res => {
    if (res.code !== 0) {
      showErrorMessage('error', res.msg)
      if (res.code === 3304) {
        session.removeTicket()
      }
      if (res.code === 3303) {
        session.removeToken();
        if (getHashUrlPathname() !== routes.login) {
          router.push({
            path: routes.login,
            query: {
              ...router.app.$route.query
            }
          })
        }
      }
    }
    return res;
  }).catch(err => {
    showErrorMessage();
    return err;
  });
};

http.get = function (path) {
  return axios.get(path).then(res => {
    return res;
  }).catch(err => {
    showErrorMessage();
    return err;
  });
};
